import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/cn";

const PROFILE_TABS = [
  { path: "/profile", label: "Overview", end: true },
  { path: "/profile/intelligence", label: "Intelligence" },
  { path: "/profile/ai-context", label: "AI Context" },
] as const;

function isActive(tabPath: string, pathname: string, end?: boolean): boolean {
  if (end) return pathname === "/profile" || pathname === "/profile/";
  return pathname === tabPath || pathname.startsWith(`${tabPath}/`);
}

export function ProfileLayout() {
  const location = useLocation();

  return (
    <>
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Profile</h1>
        <p className="text-muted-foreground">
          Identity, Candidate Intelligence Graph, and the AI context that powers Moves
          and Apply. Goals live under{" "}
          <Link to="/goals" className="text-brand hover:underline">
            Goals
          </Link>
          .
        </p>
      </header>

      <div className="mb-6 flex gap-1 overflow-x-auto border-b border-border">
        {PROFILE_TABS.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={cn(
              "relative whitespace-nowrap px-4 py-2.5 text-sm font-medium transition",
              isActive(tab.path, location.pathname, "end" in tab && tab.end)
                ? "text-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
            {isActive(tab.path, location.pathname, "end" in tab && tab.end) && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-brand" />
            )}
          </Link>
        ))}
      </div>

      <Outlet />
    </>
  );
}
